<mat-accordion class="example-headers-align w-100 mt-3 custemPanel"
>
<mat-expansion-panel   >
    <mat-expansion-panel-header >
        <div class="row w-100">
            <div class="col-3 textVersion">
                {{'languages.affaire.Version' | translate}} {{conventionData.version}} 
            </div>
            <div class="col-6">

            </div>
            <div class="col-1"> </div>
            <div class="col-2">
                <span class="btn-status d-flex justify-content-center"
                    [ngStyle]="{ color: conventionData.color, 'background-color': conventionData.background }">
                    {{conventionData.libelle}}
                </span>
            </div>

        </div>
    </mat-expansion-panel-header>
    <div class="row justify-content-center ">

        <app-form-convention 
        (onPushConvention)="getDataConvention($event)"
        [organisme_id]="organisme_id" 
        [allOrganismeList]="allOrganismeList" 
        [allGammesList]="allGammesList"
        [mode]="mode"
        [disabledName]="disabledName" 
        [conventionData]="conventionData"
        [type]="type"></app-form-convention>
        <div class="row justify-content-center mb-3" *ngIf="conventionData.status !== ConventionStatusFerme && conventionData.status !== ConventionStatusExpire">
        
            <button type="submit" class="btn-dt-save-popup  mr-2"
                 >
<i class="fa-solid fa-circle-check fa-lg mr-1"></i>
                    {{'languages.buttons.enregistrer' | translate}}
            </button>

            <button type="button" class="btn-dt-cancel-popup"
               >
<i class="fa-solid fa-circle-xmark fa-icon-style mt-1 mr-1 fa-lg"></i>
                    {{'languages.buttons.annuler' | translate}}
            </button>
          <!--   <mat-spinner *ngIf="showloaderModif || showloader " [diameter]="20"
                class="ml-2 mt-1"></mat-spinner> -->
        </div>

    </div>

</mat-expansion-panel>

</mat-accordion>
